import React, { PropsWithChildren, useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { responsive } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import useRetryOnErrorsSSO from './components/DNA/hooks/useRetryOnSSoError';
import { installIOSViewportRestoreHandler } from './utils/viewportReset';

const styles = StyleSheet.create({
  AppContainer: {
    backgroundColor: colors['color-text-white'],
    flex: 1,
    height: `var(--beacon-viewport-height, ${responsive.dimensions.trueHundredHeight})`,
    maxHeight: '-webkit-fill-available',
  },
});

const AppContainer: React.FC<PropsWithChildren> = ({ children }) => {
  useRetryOnErrorsSSO();
  useEffect(() => installIOSViewportRestoreHandler(), []);

  return (
    <View style={styles.AppContainer}>
      {children}
    </View>
  )
}
export default AppContainer;
